import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { AuthContainer, AuthContent, AuthContentInner, AuthMarketing, LayoutSplit, LoaderDots } from 'components';
import { toRem } from 'design';
import { DeviceService, InviteService } from 'lib';
import Utils from 'lib/Utils';
import { routeConstants } from 'routes';
import { loginRequest } from 'store/App';
import { selectInvite, verifyInviteRequest } from 'store/Invites';
import { AuthType, IAuthMFARequired } from 'types';
import AuthMFAVerification from './AuthMFAVerification';

interface IMFARequired {
  required: boolean;
  mfa?: IAuthMFARequired;
}

const AltAuthContentInner = styled(AuthContentInner)`
  max-width: ${toRem(480)};
`;

const AuthLogin: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [showMFAVerify, setShowMFAVerify] = useState<IMFARequired>({ required: false });
  const { search } = useLocation();
  const googleCode = new URLSearchParams(search).get('code');
  const invite = useSelector(selectInvite);
  const inviteToken = InviteService.getInviteToken();

  useEffect(() => {
    if (googleCode) {
      dispatch(loginRequest({ type: AuthType.GOOGLE, token: googleCode, deviceId: DeviceService.getDeviceId(), redirectUri: Utils.buildUrl(routeConstants.public.invites.invitesRedirectGoogle.login) }, onMFARequired, onFail));
    }
  }, [dispatch, googleCode]);

  const onMFARequired = (mfa: IAuthMFARequired) => {
    setShowMFAVerify({ required: true, mfa });
  };

  useEffect(() => {
    if (!invite && inviteToken) dispatch(verifyInviteRequest(inviteToken));
  }, [invite, inviteToken]);

  const onFail = () => {
    history.push(`${routeConstants.public.invites.login}?message=no_account_created`);
  };

  return (
    <LayoutSplit
      left={
        <AuthContainer>
          <AuthContent>
            <AltAuthContentInner>
              {showMFAVerify && showMFAVerify.mfa ? <AuthMFAVerification onBack={() => history.replace(routeConstants.public.invites.login)} mfaRequired={showMFAVerify.mfa} /> : <LoaderDots size="large" />}
            </AltAuthContentInner>
          </AuthContent>
        </AuthContainer>
      }
      right={<AuthMarketing />}
    />
  );
};

export default AuthLogin;
